var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0535 7.73867C18.9915 8.96118 19.5 10.4591 19.5 12H21.5C21.5 10.0188 20.8463 8.09295 19.6402 6.52115C18.4341 4.94935 16.7431 3.81945 14.8294 3.30667C12.9157 2.7939 10.8862 2.92691 9.05585 3.68509C8.11318 4.07555 7.25043 4.62059 6.5 5.2918V4H4.5V9H9.5V7H7.60102C8.23635 6.37751 8.98871 5.87768 9.82122 5.53285C11.2449 4.94315 12.8233 4.8397 14.3117 5.23852C15.8002 5.63735 17.1154 6.51616 18.0535 7.73867Z",
    fill: "#0BABFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.94653 16.2613C6.00846 15.0388 5.5 13.5409 5.5 12H3.5C3.5 13.9812 4.15374 15.9071 5.35982 17.4789C6.5659 19.0507 8.25693 20.1806 10.1706 20.6933C12.0843 21.2061 14.1138 21.0731 15.9442 20.3149C16.8868 19.9245 17.7496 19.3794 18.5 18.7082V20H20.5V15H15.5V17H17.399C16.7636 17.6225 16.0113 18.1223 15.1788 18.4672C13.7551 19.0569 12.1767 19.1603 10.6883 18.7615C9.19983 18.3627 7.88459 17.4838 6.94653 16.2613Z",
    fill: "#0BABFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.8105bfe42202b089814d22c7e7e59b9e.svg";
export { ForwardRef as ReactComponent };